<div id="remedial-classes" class="inner-page py-5">
  <div class="container px-lg-5">

    <!-- Header Section -->
    <div class="text-center mb-5">
      <h1 class="display-6 fw-bold text-uppercase text-orange mb-2" style="color: #f48020;">Remedial Classes</h1>
      <h4 class="fw-semibold text-dark mb-4">"Bridge the Gaps, Empower Academic Potential"</h4>
      <p class="lead text-muted mx-auto" style="max-width: 900px; line-height: 1.8; text-align: justify;">
        At Shah Satnam Ji Girls College, we believe that every student has a unique learning pace. Our Remedial Classes program is a supportive academic initiative aimed at helping slow learners, students from non-English medium backgrounds, and those who join late due to admissions catch up and excel in their curriculum.
      </p>
      <hr class="divider mx-auto" style="width: 80px; height: 3px; background: var(--primary); border: none; opacity: 1;">
    </div>

    <!-- Content Card -->
    <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5">
      
      <!-- Key Features -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Program Structure & Core Features</h5>
      <p class="text-muted mb-3">Our remedial classes are meticulously designed to provide personalized attention and positive learning spaces:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Personalized Attention:</strong> Classes are conducted in small batches to ensure teachers can address each student's specific doubts and questions.</li>
        <li class="mb-2"><strong>Simplified Conceptual Explanations:</strong> Focus on core fundamental concepts, step-by-step problem-solving, and simplified study materials.</li>
        <li class="mb-2"><strong>Bilingual Support:</strong> Explaining topics in both Hindi and English to help students transition smoothly and build confidence.</li>
        <li class="mb-2"><strong>Regular Practice Sessions:</strong> Reviewing previous years' question papers, practice tests, and providing constructive feedback.</li>
      </ul>

      <!-- Subject Scope -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Key Subjects & Support Areas</h5>
      <p class="text-muted mb-3">We provide specialized mentoring sessions across major academic streams, focusing on historically challenging subjects:</p>
      <ul class="text-muted mb-4" style="line-height: 1.8; padding-left: 20px;">
        <li class="mb-2"><strong>Mathematics & Statistics:</strong> Step-by-step guidance for algebraic, trigonometric, and analytical topics.</li>
        <li class="mb-2"><strong>English Language & Communication:</strong> Functional grammar, writing practice, reading comprehension, and spoken English confidence building.</li>
        <li class="mb-2"><strong>Science & Commerce:</strong> Support in numerical physics, chemistry equations, accountancy, and economics theories.</li>
      </ul>

      <!-- Peer Mentoring -->
      <h5 class="fw-bold text-success text-uppercase mb-3" style="letter-spacing: 0.5px;">Student Peer Mentoring & Teacher Guidance</h5>
      <p class="text-muted mb-3" style="text-align: justify; line-height: 1.8;">
        Alongside regular teacher-led remedial sessions, we encourage a peer-mentoring system where advanced students assist their classmates. This builds a warm, collaborative learning community, reduces academic anxiety, and boosts self-esteem.
      </p>

      <!-- Alert Banner -->
      <div class="p-4 rounded-4 mt-5 text-center" style="background-color: #fcece3; border: 1px solid #ffd8c3;">
        <h5 class="fw-bold mb-2" style="color: #e06c00;">"Learning is a treasure that will follow its owner everywhere."</h5>
        <p class="mb-0 fw-semibold text-muted" style="font-size: 15px;">Remedial class schedules are updated weekly on the notice board. Do not hesitate to attend!</p>
      </div>

    </div>

  </div>
</div>
